import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import axios from "../../auth/auth"; 
import logo from '../../utils/logo.png';

export default function Auth() {

  const [mode, setMode] = useState("signin");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [role, setRole] = useState("Sales");

  const navigate = useNavigate();

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    if (token) {
      navigate("/dashboard");
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (mode === "signin") {

      try {

        const res = await axios.post("/auth/login", {
          email,
          password
        });

        // Store token + role
        sessionStorage.setItem("token", res.data.access_token);
        sessionStorage.setItem("role", res.data.role);
        sessionStorage.setItem("role_id", res.data.role_id);
        sessionStorage.setItem("user_name", res.data.user_name);
        sessionStorage.setItem("user_id", res.data.user_id);

        setEmail("");
        setPassword("");

        navigate("/dashboard");

      } catch (err) {

        setError(
          err.response?.data?.detail || "Login failed"
        );
      }

    } else {

      try {

        const res = await axios.post("/auth/signup", {
          name,
          email,
          password,
          role
        });

        // If backend returns token (auto login after signup)
        if (res.data.access_token) {
          sessionStorage.setItem("token", res.data.access_token);
          sessionStorage.setItem("role", res.data.role);
          sessionStorage.setItem("user_name", res.data.user_name);
          sessionStorage.setItem("user_id", res.data.user_id);

          setEmail("");
          setPassword("");
          setName("");

          navigate("/dashboard");

        } else {
          // If backend only returns success message
          setMode("signin");
          setError("Signup successful. Please login.");
        }

      } catch (err) {

        setError(
          err.response?.data?.detail || "Signup failed"
        );
      }
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md bg-white rounded-xl shadow-sm border p-6">

        {/* Logo */}
        <div className="flex justify-center mb-8">
          <img src={logo} alt="Logo" className="h-18 w-32" />
        </div>

        <h2 className="text-center text-2xl font-semibold text-gray-900">
          Welcome
        </h2>
        <p className="text-center text-sm text-gray-500 mt-1">
          {mode === "signin"
            ? "Sign in to your account"
            : "Create a new account"}
        </p>

        {/* Toggle */}
        <div className="flex bg-gray-100 rounded-lg p-1 mt-6">
          <button
            type="button"
            onClick={() => setMode("signin")}
            className={`w-1/2 py-2 text-sm rounded-md transition ${mode === "signin"
              ? "bg-white shadow text-gray-900 font-medium"
              : "text-gray-500"
              }`}
          >
            Sign In
          </button>
          <button
            type="button"
            onClick={() => setMode("signup")}
            className={`w-1/2 py-2 text-sm rounded-md transition ${mode === "signup"
              ? "bg-white shadow text-gray-900 font-medium"
              : "text-gray-500"
              }`}
          >
            Sign Up
          </button>
        </div>

        {/* Form */}
        <form className="mt-6 space-y-4" onSubmit={handleSubmit}>

          {mode === "signup" && (
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Full Name
              </label>
              <input
                type="text"
                placeholder="Enter your full name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="mt-1 p-2 w-full bg-gray-50 rounded-md border-gray-300 focus:border-blue-500 focus:ring-blue-500"
              />
            </div>
          )}
          {mode === "signup" && (
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Role
              </label>
              <select
                value={role}
                onChange={(e) => setRole(e.target.value)}
                className="mt-1 p-2 w-full bg-gray-50 rounded-md border-gray-300"
              >
                <option value="Sales">Sales</option>
                <option value="Accounts">Accounts</option>
                <option value="Admin">Admin</option>
              </select>
            </div>
          )}

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Email
            </label>
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="mt-1 p-2 bg-gray-50 w-full rounded-md border-gray-300 focus:border-blue-500 focus:ring-blue-500"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Password
            </label>
            <div className="relative mt-1">
              <input
                type={showPassword ? "text" : "password"}
                placeholder={
                  mode === "signin"
                    ? "Enter your password"
                    : "Create a password"
                }
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full rounded-md pr-10 p-2 bg-gray-50 border-gray-300 focus:border-blue-500 focus:ring-blue-500"
              />
              <button
                type="button"
                onClick={() => setShowPassword((prev) => !prev)}
                className="absolute inset-y-0 right-2 flex items-center text-gray-500 hover:text-gray-700"
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </div>

          {error && (
            <p className="text-red-500 text-sm text-center">
              {error}
            </p>
          )}

          <button
            type="submit"
            className="w-full bg-blue-500 hover:bg-blue-600 text-white py-2.5 rounded-lg font-medium transition"
          >
            {mode === "signin" ? "Sign In" : "Create Account"}
          </button>

        </form>
      </div>
    </div>
  );
}